import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  const rawData = fetchData || {};
  const data = rawData.response?.formattedOrderAccount || [];

  console.log("formattedData Interest", data);

  const formattedData = useMemo(() => {
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return [];
    }

    let lastDate = ""; // ตัวแปรเก็บวันที่ก่อนหน้า
    let cumulativeBalance = 0; // ตัวแปรสะสมค่า balance

    return data.map((order, index) => {
      const balance = parseFloat(order.balance || "0.00");

      // สะสมค่าที่ต้องการ
      cumulativeBalance += balance;

      // จัดการวันที่
      const formattedDate = order.created_date
        ? moment(order.created_date).format("DD/MM/YYYY")
        : "";
      const displayDate = formattedDate !== lastDate ? formattedDate : "";
      lastDate = formattedDate;

      // console.log("order334", order);

      return {
        id: index + 1, // กำหนด id โดยใช้ index
        order_id: order.order_id || "",
        order_code: order.order_code || "",
        status: order.status || "",
        balance: balance.toFixed(2),
        cumulative_balance: cumulativeBalance.toFixed(2), // ใช้ค่าที่สะสม
        date: displayDate, // แสดงวันที่เฉพาะเมื่อไม่ซ้ำ
      };
    });
  }, [data]);

  return formattedData;
};

export default useProductData;
